/**
 * Created by - Ashlekh on 24-04-2025
 * Reason - To display Ward wise details of members
 */
import { Modal } from "antd";
import parse from "html-react-parser";
import { useContext, useEffect, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import config from "../../Api/config";
import { getMemberDetailsListAPI } from "../../Api/services";
import NavigationPath from "../../components/NavigationPath/NavigationPath";
import { GlobalContext } from "../../context/Context";
import style from "./MemberDetailWardWise.module.css";

const MemberDetailWardWise = () => {
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);
  const [showContent, setShowContent] = useState(false);
  const location = useLocation();
  // const id = location?.state?.id || {};
  // Added by - Yogen  on 12-06-2025
  // Reason - useLocation Used for displaying ward title from member page
  const { id, ward_name } = location?.state || "";
  // End of code - Yogen on 12-06-2025
  // Reason - useLocation Used for displaying ward title from member page
  const [memberDetails, setMemberDetails] = useState([]);
  // Added by - Ashlekh on 26-04-2025
  // Reason - useState used for antd modal
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  // End of code - Ashlekh on 26-04-2025
  // Reason - useState used for antd modal
  // Added by - Ashlekh on 24-04-2025
  // Reason - This useEffect will execute when page loads
  useEffect(() => {
    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "Member List", path: "/member_list" },
    ]);
    window.scrollTo(0, 0);
    memberDetailsList(id);
  }, []);
  // End of code - Ashlekh on 24-04-2025
  // Reason - This useEffect will executes when page loads

  // Added by - Ashlekh on 24-04-2025
  // Reason - To get details from backend
  const memberDetailsList = async (id) => {
    try {
      const response = await getMemberDetailsListAPI(id);
      setMemberDetails(response?.member_details_ward_wise);
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setShowContent(true);
    }
  };
  // End of code - Ashlekh on 24-04-2025
  // Reason - To get details from backend

  // Added by - Ashlekh on 26-04-2025
  // Reason - To open/close antd modal
  const showModal = (member) => {
    setSelectedMember(member);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // End of code - Ashlekh on 26-04-2025
  // Reason - To open/close antd modal

  // Code changed by - Ashlekh on 02-06-2025
  // Reason - To hide registration number column if registration number is not present in every row
  const shouldShowRegistrationColumn = memberDetails?.some(
    (item) =>
      item.registration_number && item.registration_number.trim().length > 0
  );
  // End of code - Ashlekh on 02-06-2025
  // Reason - To hide registration number column if registration number is not present in every row
  return (
    <div>
      {showContent ? (
        <div className={`${style.mainContainer}`}>
          <NavigationPath navigationPathArray={navigationPath} />
          <div className={`${style.pageTitle}`}>{ward_name}</div>
          {memberDetails?.length > 0 ? (
            <div>
              {/* <div className={`${style.pageTitle}`}>Members List</div> */}
              {/* Added by - Yogen on 12-06-2025
                  Reason - To display ward name as header */}
              {/* End of code - Yogen on 12-06-2025 
                  Reason -  To display ward name as header */}

              {/* {memberDetails?.length > 10 && (     */}

              <div className={`${style.memberDetailsTable}`}>
                <table className={`${style.tableHeading}`}>
                  <thead>
                    <tr>
                      {/* Added by - Yogen on 12-06-2025
                          Reason - To add serial number and ward details header*/}
                      <th className={`${style.tableHeader} ${style.serialNo}`}>
                        S.No.
                      </th>
                      <th
                        className={`${style.tableHeader} ${style.wardDetails}`}
                      >
                        Ward Details
                      </th>
                      {/* End of code - Yogen on 12-06-2025 
                          Reason - To add serial number and ward details header*/}

                      {/* Code changed by - Ashlekh on 02-06-2025
                      Reason - To hide registration number column if registration number is not present in every row */}
                      {shouldShowRegistrationColumn && (
                        <th
                          className={`${style.tableHeader} ${style.registrationNumber}`}
                        >
                          Registration Number
                        </th>
                      )}
                      {/* End of code - Ashlekh on 02-06-2025
                      Reason - To hide registration number column if registration number is not present in every row */}
                      <th
                        className={`${style.tableHeader} ${style.nameHeading}`}
                      >
                        Name
                      </th>
                      <th
                        className={`${style.tableHeader} ${style.contactNumberHeading}`}
                      >
                        Contact Number
                      </th>
                      <th
                        className={`${style.tableHeader} ${style.viewProfileHeading}`}
                      >
                        {/* View Profile */}
                        View Photo
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {memberDetails?.map((item, index) => (
                      <tr key={index}>
                        {/* Code changed by - Ashlekh on 02-06-2025
                        Reason - To hide registration number column if registration number is not present in every row */}
                        {/* <td
                          className={`${style.tableCell} ${style.registrationNumber}`}
                        >
                          {item.registration_number}
                        </td> */}
                        {/* Added by - Yogen on 12-06-2025
                          Reason - To add serial number and ward details data */}
                        <td className={`${style.tableCell} ${style.serialNo}`}>
                          {index + 1}
                        </td>
                        <td
                          className={`${style.tableCell} ${style.wardDetails}`}
                        >
                          {/* {parse(item.description || "-")} */}
                           {/* {item.ward_detail} */}
                           {item.ward_detail && item.ward_detail.trim().length > 0 ? item.ward_detail : "-"}
                        </td>
                        {/* End of code - Yogen on 12-06-2025 
                          Reason - To add serial number and ward details data */}
                        {shouldShowRegistrationColumn && (
                          <td
                            className={`${style.tableCell} ${style.registrationNumber}`}
                          >
                            {item.registration_number &&
                            item.registration_number.trim().length > 0
                              ? item.registration_number
                              : "-"}
                          </td>
                        )}
                        {/* End of code - Ashlekh on 02-06-2025
                        Reason - To hide registration number column if registration number is not present in every row */}
                        <td className={`${style.tableCell} ${style.nameData}`}>
                          {item.name}
                        </td>
                        <td
                          className={`${style.tableCell} ${style.contactNumberData}`}
                        >
                          {item.mobile_number}
                        </td>
                        <td className={`${style.tableCell}`}>
                          {/* <FaEye
                            className={`${style.eyeIconContainer}`}
                            onClick={() => showModal(item)}
                            color="black"
                          /> */}
                          {/* Added by : Yogen on 26/06/2025 
                              Reason : To show cross eye if Photo is not exist   */}
                          {item.image?.length > 0 ? (
                            <FaEye
                              className={`${style.eyeIconContainer}`}
                              onClick={() => showModal(item)}
                              color="black"
                            />
                          ) : (
                            <FaEyeSlash
                              className={`${style.eyeIconContainer}`}
                              color="black"
                            />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <Modal
                  open={isModalVisible}
                  onCancel={handleCancel}
                  footer={null}
                  // Added By yogen on 17/06/2025 reason for fix the width of modal
                  width={350}
                  // Ended By yogen on 17/06/2025 reason for fix the width of modal
                >
                  <div className={style.memberDetailsContainer}>
                    {/* <div className={`${style.memberName}`}>
                      Name: {selectedMember?.name}
                    </div>
                    <div className={`${style.memberMobileNumber}`}>
                      Contact Number: {selectedMember?.mobile_number}
                    </div> */}
                    {/* Added by - Ashlekh on 12-06-2025
                    Reason - To add condition for registration number */}
                    {/* {selectedMember?.registration_number && ( */}
                    {/* // End of code - Ashlekh on 12-06-2025
                    // Reason - To add condition for registration number */}
                    {/* <div className={`${style.memberRegistrationNumber}`}>
                        Registration Number: {selectedMember?.registration_number}
                      </div> */}
                    {/* )} */}
                    {/* <div className={`${style.memberDescription}`}>
                      {parse(selectedMember?.description || "")}
                    </div> */}
                    {/* Added by - Yogen on 16-06-2025
                        Reason - To display image inside the model  */}
                    <div className={style.memberImageContainer}>
                      <img
                        src={`${config.baseURL}/${selectedMember?.image}`}
                        alt="Image"
                        className={style.memberImage}
                      />{" "}
                    </div>
                    {/* End of code - Yogen on 16-06-2025 
                        Reason - To display image inside the model  */}
                  </div>
                </Modal>
              </div>
            </div>
          ) : (
            <p className={style.noDetailsAvailableText}>No details available</p>
          )}
        </div>
      ) : (
        <div className={style.loaderContent}>
          <img style={{ height: "30vh" }} src="/adyant_loader.gif" />
        </div>
      )}
    </div>
  );
};
export default MemberDetailWardWise;
